import { InvokeCallback, Sender } from "xstate";
import { Dividend, listAndSearchAllDividends } from "@rentablo/api/apiv1";
import { withToken } from "@rentablo/api";
import { DividendWizardContext } from "../types/dividendWizardContext";
import { DividendWizardEvent } from "../types/dividendWizardEvent";

export const loadTaxAmount =
  (
    context: DividendWizardContext,
    event: DividendWizardEvent
  ): InvokeCallback<DividendWizardEvent, DividendWizardEvent> =>
  async (callback) => {
    if (event.type !== "SKIP_TAX" && event.type !== "TAX_ENTERED") {
      throw new Error(`Invalid event type ${event.type}`);
    }

    load(
      context.investment?.id ?? 0,
      context.customTaxAmount,
      context.selectedDividends,
      context.splitAdjust,
      callback
    );
  };

const load = async (
  investmentId: number,
  taxRate: number,
  selectedDividends: Dividend[],
  splitAdjust: boolean,
  callback: Sender<DividendWizardEvent>
) => {
  try {
    const { dividends = [] } = await withToken(listAndSearchAllDividends)({
      investmentId: [investmentId],
      excludeImported: false,
      taxRate,
      splitAdjust,
    });

    const selectedDividendsWithTaxRate = dividends.filter(({ date }) =>
      selectedDividends.some(({ date: responseDate }) => date === responseDate)
    );

    callback({
      type: "TAX_RATE_LOADED",
      selectedDividendsWithTaxRate: selectedDividendsWithTaxRate as Dividend[],
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
